/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Pure_Crow_DartInputs */

const en_happy_pure_crow_dart = /** @type {(inputs: Happy_Pure_Crow_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure user roles and access permissions. Roles determine which features and data the user can access. Enabling login access allows the member to sign in to the portal.`)
};

const de_happy_pure_crow_dart = /** @type {(inputs: Happy_Pure_Crow_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konfigurieren Sie Benutzerrollen und Zugriffsberechtigungen. Rollen bestimmen, auf welche Funktionen und Daten der Benutzer zugreifen kann. Die Aktivierung des Login-Zugriffs ermöglicht es dem Benutzer, sich im Portal anzumelden.`)
};

/**
* | output |
* | --- |
* | "Configure user roles and access permissions. Roles determine which features and data the user can access. Enabling login access allows the member to sign in ..." |
*
* @param {Happy_Pure_Crow_DartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const happy_pure_crow_dart = /** @type {((inputs?: Happy_Pure_Crow_DartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Pure_Crow_DartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_happy_pure_crow_dart(inputs)
	return de_happy_pure_crow_dart(inputs)
});